<template>
  <div class="flex justify-between items-center p-5">
    <div class="flex items-center">
      <img :src="file.iconUrl" alt="Icon Image" class="h-10">
      <div class="mx-5">
        <div v-if="hasPurchased" class="underline cursor-pointer font-bold" @click="downloadItem()">
          {{ file.name }}
        </div>
        <div v-else class="font-bold">
          {{ file.name }}
        </div>
        <p class="text-sm" v-html="file.description" />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  // Import Pinia auth store
  import { useAuthStore } from '@stores/auth';
  import { ContentListingInteractionType, ListingItemType } from '@resources/scripts/constants';

  export default {
    inject: ['contentListing', 'hasPurchased'],
    props: {
      file: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        auth: null,
      };
    },

    computed: {
      profile() {
        return this.auth ? this.auth.profile || {} : {};
      },
    },
    mounted() {
      this.auth = useAuthStore();
    },

    methods: {
      async downloadItem() {
        // Submit the interaction for historical tracking
        if (this.profile && this.file.type === ListingItemType.FILE) {
          await axios.post(`/api/content-listings/${this.contentListing.id}/interactions`, {
            type: ContentListingInteractionType.DOWNLOAD,
            userId: this.profile.id,
            contentListingId: this.contentListing.id,
            contentListingItemId: this.file.id,
            startTime: new Date(),
            stopTime: new Date(),
          });
        }

        // Download the file
        const { data } = await axios.get(`/api/content-listings/items/static/${this.file.id}/download-url`);
        const ios = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
        if (ios) {
          window.location.href = data;
        } else {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.target = '_blank';
          a.href = data;
          a.click();
          document.body.removeChild(a);
        }
      },
    },
  };
</script>